import type { FaireProductEntity } from "../../entity_types/product";

export const p_5bcwvpeg8e: FaireProductEntity = {
  token: "p_5bcwvpeg8e",
  type: "product",
  name: "DOUBLE DOUBLE",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/21382c40e921909c2c8c35d99a6eb1ef5598983c8fd0c79e6182167058438d19.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd3132078b95b00f6cab497d49b6b015401e78911c1297de98fe5548794cf148.jpeg",
    "https://cdn.faire.com/fastly/1afc0ed9ff021c14a312af6d477a1bf3c603af029b55cf62a00e9e12591b2810.png",
    "https://cdn.faire.com/fastly/7ffc548f269cfe0986ea9dee91aecc38b4b3b37ba33fc07282b1fdd4e67e3338.png",
    "https://cdn.faire.com/fastly/604d702107bbdcf37f9d29b8527ce667fef8587ae070a73d1c1d9755df46b459.png",
    "https://cdn.faire.com/fastly/f7985db10b4778f6310ce06c907fc552b5088d5b6bac3516b9300c4e67270c1b.png",
    "https://cdn.faire.com/fastly/6fd776e21d17083d3916e13470dac8e3f2d8ef74a7e8d8d59e30a07a3c6effb6.png"
  ],
  priceDollars: 11.55,
  description: "Built for espresso, smooth enough for drip.\n\nTasting Notes: Brown sugar, light cherry.\n\nFarm: UVI Recruitment\n\nLocation: Andes, Antioquia, Colombia and Montebello, Antioquia, Colombia\n\nAltitude: 1800 - 2000 masl\n\nVariety: Castillo, Colombia and Caturra\n\nProcess: Washed\n\nRoast Level: Medium\n\nRecommended Brew: Espresso, drip, or moka pot\n\nAbout the Coffee:\n\nUnblended Coffee is based in Buga, Colombia, and works with coffee producers willing to push the envelope in search of a more transparent and quality-driven supply chain. UVI is Unblended Coffee's education program that helps newer farmers position their brand internationally, improving their company's profitability.\n\nThis coffee was named Double Double to express that everybody wins! Y'all get double the flavor, with double the purpose: both being able to enjoy an amazing coffee while investing in the future of farming. This collaboration with Unblended is intended to boost UVI's mission to invest in young coffee farmers and to change the image of coffee farming in all coffee consumers' minds.\n",
  tags: [],
  msrpDollars: 19.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:36.565Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
